import { useState, useEffect } from 'react';

function mergeStored(storedValueParsed, defaultValue) {
    return (defaultValue || []).map((item, _) => {
        const storedItem = (storedValueParsed || []).find((e) => e.atributo === item?.atributo);
        return { ...item, valor: storedItem?.valor || item?.valor || '' };
    });
}

function usePersistendStateAbstract(key, defaultValue) {
    const [state, setState] = useState(() => {
        const storedValue = sessionStorage.getItem(key);
        return storedValue !== null ? mergeStored(JSON.parse(storedValue), defaultValue) : defaultValue;
    });

    useEffect(() => {
        sessionStorage.setItem(key, JSON.stringify(state));
    }, [key, state]);

    return [state, setState];
}

function usePersistedState(key, filtros) {
    return usePersistendStateAbstract(key, filtros.filter((filtro) => filtro?.hidden !== true));
}

export default usePersistedState;
